"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileValidationError = void 0;
const react_1 = __importDefault(require("react"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const paperclip_svg_1 = __importDefault(require("../../icons/paperclip.svg"));
const blobFunctions_1 = require("../../utils/blobFunctions");
const Dimensions_1 = __importDefault(require("../../utils/Dimensions"));
const constants_1 = require("../../constants");
var FileValidationError;
(function (FileValidationError) {
    FileValidationError[FileValidationError["FileTooBig"] = 0] = "FileTooBig";
})(FileValidationError = exports.FileValidationError || (exports.FileValidationError = {}));
exports.default = react_1.default.memo(AttachFile);
function AttachFile(props) {
    return (react_1.default.createElement(IconButton_1.default, { component: "label", className: props.className },
        react_1.default.createElement(paperclip_svg_1.default, null),
        react_1.default.createElement("input", { hidden: true, type: "file", onChange: onMediaSelected })));
    function onMediaSelected(event) {
        let files = event.target.files;
        if (!files || !files[0]) {
            return;
        }
        const file = files[0];
        const reader = new FileReader();
        reader.onload = function (e) {
            return __awaiter(this, void 0, void 0, function* () {
                const mimeType = file.type;
                const data = e.target.result;
                let content;
                if ((mimeType.startsWith("image/") && data.byteLength > constants_1.MAX_IMAGE_SIZE) ||
                    (mimeType.startsWith("video/") && data.byteLength > constants_1.MAX_VIDEO_SIZE) ||
                    (data.byteLength > constants_1.MAX_FILE_SIZE)) {
                    props.onFileValidationError(FileValidationError.FileTooBig, mimeType);
                    return;
                }
                if (mimeType.startsWith("video/") || mimeType.startsWith("image/")) {
                    const blobUrl = blobFunctions_1.dataToBlobUrl(data, mimeType);
                    const extract = mimeType.startsWith("image/")
                        ? yield extractImageThumbnail(blobUrl)
                        : yield extractVideoThumbnail(blobUrl);
                    content = {
                        kind: "media",
                        caption: null,
                        mimeType: mimeType,
                        width: extract.dimensions.width,
                        height: extract.dimensions.height,
                        data: new Uint8Array(e.target.result),
                        blobUrl,
                        thumbnailData: extract.thumbnailData
                    };
                }
                else {
                    content = {
                        kind: "file",
                        caption: null,
                        name: file.name,
                        mimeType: mimeType,
                        data: new Uint8Array(e.target.result)
                    };
                }
                props.onFileSelected(content);
            });
        };
        reader.readAsArrayBuffer(file);
    }
    function extractImageThumbnail(blobUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, _) => {
                const img = new Image;
                img.onload = function () {
                    const extract = extractThumbnail(img, new Dimensions_1.default(img.width, img.height));
                    resolve(extract);
                };
                img.src = blobUrl;
            });
        });
    }
    function extractVideoThumbnail(blobUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, _) => {
                const video = document.createElement("video");
                video.addEventListener("loadedmetadata", function () {
                    video.addEventListener("seeked", function () {
                        const extract = extractThumbnail(video, new Dimensions_1.default(this.videoWidth, this.videoHeight));
                        resolve(extract);
                    });
                    video.currentTime = 1;
                });
                video.src = blobUrl;
            });
        });
    }
    function extractThumbnail(original, dimensions) {
        const thumbnailDimensions = dimensions.scaleToFit(new Dimensions_1.default(25, 25));
        const canvas = document.createElement("canvas");
        canvas.width = thumbnailDimensions.width;
        canvas.height = thumbnailDimensions.height;
        const context = canvas.getContext("2d");
        context.drawImage(original, 0, 0, canvas.width, canvas.height);
        return {
            dimensions: dimensions,
            thumbnailData: canvas.toDataURL()
        };
    }
}
